export default {
  install(Vue) {
    Vue.mixin({
      data() {
        return {
          isUploading: false, // 组件的状态
        };
      },
      methods: {
        debouncedUpload(uploadRef, delay = 1000) {
          return () => {
            if (this.isUploading) return; // 防止多次提交
            this.isUploading = true; // 设置为正在上传
            uploadRef.submit(); // 提交上传
            setTimeout(() => {
              this.isUploading = false; // 1秒后重置状态
            }, delay);
          };
        },
      },
    });
  },
};


// WEBPACK FOOTER //
// ./src/mixin/uploadPlugin.js